export function reorderColumns(columns, columnSequence) {
  if (!columnSequence) {
    return columns;
  }

  return [...columns].sort(
    (columnA, columnB) => columnSequence[columnA.id] - columnSequence[columnB.id]
  );
}

export function mergeColumnVisibility(columns, previousColumns) {
  const visibilityById = new Map(
    (previousColumns || []).map((column) => [column.id, column.isHidden])
  );

  return columns.map((column) => ({
    ...column,
    isHidden: visibilityById.has(column.id)
      ? visibilityById.get(column.id)
      : column.isHidden,
  }));
}

export function filterBoardCards(cards = [], filters) {
  const {
    assigneeSearch,
    epicSearch = [],
    noMilestoneSearch,
    searchText,
    statusSearch,
    estimated,
    columnHeaderStatus,
    columnHeaderMilestone,
    columnHeaderAssignee,
  } = filters;

  return cards.filter((cardData) => {
    const title = `${cardData?.card?.title || ""}`.toLowerCase();
    const cardId = cardData?.card?.card_id?.toString()?.toLowerCase() || "";
    const assigneeFirstName =
      `${cardData?.card?.assigned_to_user?.first_name || ""}`.toLowerCase();
    const userId = cardData?.card?.assigned_to_user?.user_id?.toString();

    if (
      assigneeSearch.length &&
      !assigneeSearch.includes(cardData?.card?.assigned_to_user_id)
    ) {
      return false;
    }

    if (epicSearch.length && !epicSearch.includes(cardData?.card?.epic_id)) {
      return false;
    }

    if (noMilestoneSearch === "true" && cardData?.card?.epic_id != null) {
      return false;
    }

    if (
      searchText &&
      !title.includes(searchText) &&
      !cardId.includes(searchText) &&
      !assigneeFirstName.includes(searchText)
    ) {
      return false;
    }

    if (
      statusSearch &&
      `${cardData?.card?.workflow_step_id}` !== `${statusSearch}`
    ) {
      return false;
    }

    if (
      columnHeaderStatus.length &&
      !columnHeaderStatus.includes(cardData?.card?.workflow_step_id?.toString())
    ) {
      return false;
    }

    if (
      columnHeaderMilestone.length &&
      !columnHeaderMilestone.includes(cardData?.card?.epic?.epic_id?.toString())
    ) {
      return false;
    }

    if (
      columnHeaderAssignee.length &&
      !columnHeaderAssignee.includes(userId) &&
      !(columnHeaderAssignee.includes("unassigned") && !userId)
    ) {
      return false;
    }

    if (estimated && estimated !== "All") {
      if (estimated === "Watching" && !cardData?.card?.is_watch_list) {
        return false;
      }

      if (estimated === "Estimated" && !cardData?.card?.allocated_hours) {
        return false;
      }

      if (estimated === "Not Estimated" && cardData?.card?.allocated_hours) {
        return false;
      }
    }

    return true;
  });
}

export function buildListViewRows(boardCards = []) {
  return boardCards.map((boardCard) => ({
    id: boardCard?.card?.card_id,
    is_todo: boardCard?.card?.is_todo,
    cardId: boardCard?.card?.card_id,
    title: boardCard?.card?.title,
    date_created: boardCard?.card?.date_created,
    assigned_to_user_name:
      boardCard?.card?.assigned_to_user?.first_name || "z",
    isSubtask: boardCard?.sub_tasks?.length > 0,
    ...boardCard,
    subRow:
      boardCard?.subRow?.length > 0
        ? boardCard.subRow.map((cardSubTask) => ({
            id: cardSubTask?.card_id,
            ...cardSubTask,
            key: boardCard?.key,
            board_name: boardCard?.board_name,
            board_admin: boardCard?.board_admin,
          }))
        : null,
  }));
}

export function getUniqueMilestones(cards = [], epicSearch) {
  const parsedMilestoneSearch = Number(epicSearch);
  const epics = cards
    .map((item) => item.card?.epic)
    .filter((epic) =>
      parsedMilestoneSearch
        ? epic?.epic_id === parsedMilestoneSearch
        : epic?.epic_id != null
    );

  return [...new Map(epics.map((epic) => [epic.epic_id, epic])).values()];
}

export function getUniqueAssignees(cards = [], filterUser) {
  const parsedAssigneeSearch = Number(filterUser);
  const assignees = cards
    .map((item) => item?.card?.assigned_to_user)
    .filter((assignee) =>
      parsedAssigneeSearch
        ? assignee?.user_id === parsedAssigneeSearch
        : assignee != null
    );

  return [
    ...new Map(assignees.map((assignee) => [assignee?.user_id, assignee])).values(),
  ];
}
